import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App as AntdApp, ConfigProvider as AntdConfigProvider, theme } from 'antd';
import { Provider as ReduxProvider } from 'react-redux';
import store from '@/redux';
import 'antd/dist/reset.css'; // Import antd styles BEFORE Tailwind
import './window.d.ts';
import './index.css';
import './tailwind.css';
import { RouterProvider } from 'react-router';
import { agGridInit } from '@/utils/ag-grid-init.ts';
import { AntdAppFeedbackBridge } from '@/utils/antdAppFeedback.ts';
import { dayJsInit } from '@/utils/day-js-init.ts';
import { router } from '@/router';

agGridInit();
dayJsInit();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AntdConfigProvider
      theme={{
        algorithm: theme.defaultAlgorithm,
      }}
    >
      <AntdApp className="w-full h-full">
        <AntdAppFeedbackBridge />
        <ReduxProvider store={store}>
          <RouterProvider router={router} />
        </ReduxProvider>
      </AntdApp>
    </AntdConfigProvider>
  </StrictMode>,
);
